import { getWindRoseData } from "../../data/ramotswe";
import {
  getCurrentObservatoryName,
  removeChildrenIfPopulated,
} from "../../utils";
import { WindRoseGraph } from "../../graphs/base_graphs";

export default async function initializeWindRose() {
  async function refresh() {
    const observatoryName = getCurrentObservatoryName();
    removeChildrenIfPopulated("#wind-rose-graph-hourly");
    removeChildrenIfPopulated("#wind-rose-graph");
    removeChildrenIfPopulated("#wind-rose-graph-monthly");
    removeChildrenIfPopulated("#wind-rose-graph-legend");

    // Set up weekly windrose
    const hourlyWindRoseData = await getWindRoseData(observatoryName, {
      hours: 1,
    });

    const hourlyWindRose = new WindRoseGraph(
      "#wind-rose-graph-hourly",
      hourlyWindRoseData
    );

    // Set up weekly windrose
    const weeklyWindRoseData = await getWindRoseData(observatoryName, {
      weeks: 1,
    });

    const weeklyWindRose = new WindRoseGraph(
      "#wind-rose-graph",
      weeklyWindRoseData
    );

    // Set up monthly windrose
    const monthlyWindRoseData = await getWindRoseData(observatoryName, {
      weeks: 4,
    });

    const monthlyWindRose = new WindRoseGraph(
      "#wind-rose-graph-monthly",
      monthlyWindRoseData
    );

    // add legend
    removeChildrenIfPopulated("#wind-rose-graph-legend");
    const legend = weeklyWindRose.addLegend("#wind-rose-graph-legend");
  }

  await refresh();

  return refresh;
}
